module.exports = __webpack_public_path__ + "static/media/IsometricPullFemale.2aaaa6e4.svg";